export default "__VITE_ASSET__9uWf7php__"